<template>
  <div>
    <div>
      <QSelect
        v-model="filters[IRecruitmentCandidatesFilters.locations]"
        use-input
        options-selected-class="text-accent"
        multiple
        use-chips
        hide-selected
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@LOCATION')"
        :options="locationOptions"
        :option-label="(opt) => opt.getLabel()"
        @input-value="setCities"
        @update:model-value="applyFilters"
      >
        <template #prepend>
          <QIcon name="location_on" />
        </template>
        <template #no-option>
          <QItem>
            <QItemSection class="text-grey">
              {{ $t("ETAB.PAGES.CANDIDATE.FILTERS.@NO_LOCATION_RESULTS") }}
            </QItemSection>
          </QItem>
        </template>
      </QSelect>
      <div class="q-mt-md">
        <QChip
          v-for="(location, index) in filters.getLocations()"
          :key="index"
          :label="location.getCity()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(location, filters[IRecruitmentCandidatesFilters.locations])"
        />
      </div>
      <QSelect
        v-model="filters[IRecruitmentCandidatesFilters.languages]"
        options-selected-class="text-accent"
        :options="languageOptions"
        :option-label="(opt) => opt.getLabel()"
        multiple
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@LANGUAGE')"
        @update:model-value="applyFilters"
      />
      <div class="q-mt-md">
        <QChip
          v-for="(language, index) in filters.getLanguages()"
          :key="index"
          :label="language.getLabel()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(language, filters[IRecruitmentCandidatesFilters.languages])"
        />
      </div>
      <QSelect
        v-model="filters[IRecruitmentCandidatesFilters.workExperiences]"
        options-selected-class="text-accent"
        :options="experienceOptions"
        :option-label="(opt) => opt.getLabel()"
        multiple
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@EXPERIENCE', { qualification: recruitment?.getQualificationLabel() })"
        @update:model-value="applyFilters"
      />
      <div class="q-mt-md">
        <QChip
          v-for="(experience, index) in filters.getExperiences()"
          :key="index"
          :label="experience.getLabel()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(experience, filters[IRecruitmentCandidatesFilters.workExperiences])"
        />
      </div>
    </div>
    <div>
      <QToggle
        v-model="filters[IRecruitmentCandidatesFilters.hasRecommendation]"
        :true-value="1"
        :false-value="0"
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_RECOMMENDATION')"
        @update:model-value="applyFilters"
      />
      <QIcon size="sm" class="q-ml-md" color="primary" name="help_outline">
        <QTooltip class="bg-indigo" anchor="top middle" :offset="[10, 10]">
          {{ $t("ETAB.PAGES.CANDIDATE.FILTERS.@RECOMMENDATION_TOOLTIP") }}
        </QTooltip>
      </QIcon>
      <br />
      <QToggle
        v-model="filters[IRecruitmentCandidatesFilters.alreadyWorkedIn]"
        :true-value="1"
        :false-value="0"
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_ALREADY_WORKED_IN', { category: recruitment?.getEtabFamilyGroupName() })"
        @update:model-value="applyFilters"
      />
      <br />
      <QToggle
        v-model="filters[IRecruitmentCandidatesFilters.hasVehicle]"
        :true-value="1"
        :false-value="0"
        :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_VEHICLE')"
        @update:model-value="applyFilters"
      />
    </div>
  </div>
</template>

<script>
  import { JavascriptHelpers } from "@core/helpers";
  import { RecruitmentCandidatesFiltersModel, IRecruitmentCandidatesFilters } from "@core/models";
  import { useProfileStore } from "@etab/stores/profile";
  import { useRecruitmentCandidatesFiltersStore } from "@etab/stores/recruitment-candidates-filters";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { mapState } from "pinia";
  import {
    GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS,
    GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS,
    GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS,
    GETTER_RECRUITMENT_GET_CURRENT,
    GETTER_PROFILE_GET,
  } from "@etab/stores/types"; // pinia

  export default {
    props: {
      displayFilter: {
        type: Boolean,
        default: false,
      },
      filters: {
        type: Object,
        default: () => new RecruitmentCandidatesFiltersModel(),
      },
      emitOnInput: {
        type: Boolean,
        default: true,
      },
    },
    emits: ["applyFilters", "searchLocation"],
    data() {
      return {
        locations: undefined,
        languages: undefined,
        experiences: undefined,
        alreadyWorkedIn: 0,
        hasVehicle: 0,
        hasRecommendation: 0,
        activateLoading: false,
        filteredLocationOptions: [],
      };
    },
    computed: {
      ...mapState(useProfileStore, {
        etabProfile: GETTER_PROFILE_GET,
      }),
      ...mapState(useRecruitmentCandidatesFiltersStore, {
        languageOptions: GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS,
        experienceOptions: GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS,
        locationOptions: GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS,
      }),
      ...mapState(useRecruitmentStore, {
        recruitment: GETTER_RECRUITMENT_GET_CURRENT,
      }),
    },
    created() {
      this.IRecruitmentCandidatesFilters = IRecruitmentCandidatesFilters;
    },
    methods: {
      applyFilters() {
        if (this.emitOnInput) {
          this.$emit("applyFilters");
        }
      },
      setCities(val) {
        this.$emit("searchLocation", val);
      },
      capitalizeFirstLetterOption(option) {
        return JavascriptHelpers.capitalizeFirstLetter(option);
      },
      remove(selected, filters) {
        this.filters.removeFilters(selected, filters);
        this.$emit("applyFilters");
      },
    },
  };
</script>
